import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { APP_ICONS } from "../../assets";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
    },
  },
  "& .MuiPaper-root": {
    width: "550px",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const ImageViewDialog = forwardRef(({ handleSuspend }, ref) => {
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState("");

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setImage(paramsData?.returnImages[0]);
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogContent>
        <Stack
          direction={"row"}
          gap={1}
          height={230}
          width={"100%"}
          borderRadius={5}
          border={"2px solid #003B95"}
          justifyContent={"center"}
        >
          <img src={image} height={"100%"} width={260} />
        </Stack>
        {paramsData?.returnImages?.map((image, index) => {
          return (
            <Stack
              direction={"row"}
              gap={1}
              height={100}
              width={100}
              mt={1}
              borderRadius={5}
              border={"2px solid #003B95"}
              overflow={"hidden"}
              onClick={() => setImage(image)}
            >
              <img src={image} height={"100%"} width={"100%"} />
            </Stack>
          );
        })}
        <Stack direction={"row"} alignItems={"center"} gap={1} mt={6}>
          <Button variant="custom_outlined" onClick={handleClose}>
            Close
          </Button>
        </Stack>
      </DialogContent>
    </BootstrapDialog>
  );
});

export default ImageViewDialog;
